import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';

const RATE_TYPES = [
  { key: 'per_hour', label: 'Per Hour' },
  { key: 'per_trip', label: 'Per Trip' },
  { key: 'per_half_day', label: 'Per Half Day (4 hrs max)' },
  { key: 'per_day', label: 'Per Day' },
  { key: 'ot', label: 'OT after 7pm x1.5 Per Hour' },
];

export const STANDARD_RATES = [
  { name: '25-ton Lorry Crane (3 hours max)', per_hour: 80, per_trip: 240, per_half_day: null, per_day: 640, ot: 120 },
  { name: '40-ton Lorry Crane (3 hours max)', per_hour: 120, per_trip: 360, per_half_day: null, per_day: 960, ot: 180 },
  { name: '55-ton Lorry Crane (4 hours max)', per_hour: 180, per_trip: null, per_half_day: 720, per_day: 1440, ot: 270 },
  { name: '55-ton Fly Jib (4 hours max)', per_hour: 200, per_trip: null, per_half_day: 800, per_day: 1600, ot: 300 },
  { name: '75-ton Lorry Crane (4 hours max)', per_hour: 240, per_trip: null, per_half_day: 960, per_day: 1920, ot: 360 },
  { name: '75-ton Fly Jib w Winch (4 hours max)', per_hour: 220, per_trip: null, per_half_day: 880, per_day: 1760, ot: 330 },
  { name: '100-ton Lorry Crane (4 hours max)', per_hour: 250, per_trip: null, per_half_day: 1000, per_day: 2000, ot: 375 },
  { name: '100-ton Fly Jib w Winch (4 hours max)', per_hour: 300, per_trip: null, per_half_day: 1200, per_day: 2400, ot: 450 },
  { name: 'Lowbed Trailer (less than 30-ton)', per_hour: 80, per_trip: null, per_half_day: 320, per_day: 640, ot: 120 },
  { name: 'Lowbed Trailer (less than 60-ton)', per_hour: 90, per_trip: null, per_half_day: null, per_day: 720, ot: 135 },
  { name: 'Lowbed Trailer w Auto Ram (less than 32-ton)', per_hour: 120, per_trip: null, per_half_day: 480, per_day: 960, ot: 180 },
  { name: '14FT Tailgate Box Lorry', per_hour: 90, per_trip: 180, per_half_day: null, per_day: 720, ot: 135 },
  { name: '24FT Tailgate Box / Canopy Lorry', per_hour: 120, per_trip: 240, per_half_day: null, per_day: 960, ot: 180 },
  { name: 'Manpower (Per Pax)', per_hour: 50, per_trip: null, per_half_day: 200, per_day: 400, ot: 75 },
  { name: 'Equipment: pallet jack, wrapping etc', per_hour: null, per_trip: null, per_half_day: null, per_day: 200, ot: null },
];

export const rateToLineItem = (item, rateKey) => {
  const rt = RATE_TYPES.find((r) => r.key === rateKey);
  return {
    description: `Supply of ${item.name} — ${rt.label}`,
    quantity: 1,
    hours: 0,
    unit_price: item[rateKey],
    amount: item[rateKey],
  };
};

export const RateCardLibrary = ({ onAdd }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-4 border border-amber-200 bg-amber-50/50 rounded-lg p-3" data-testid="rate-card-library">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="text-sm font-semibold text-amber-800 flex items-center gap-1"
        data-testid="rate-card-toggle"
      >
        <BookOpen size={14} /> Standard Rate Card {open ? '▾' : '▸'}
        <span className="font-normal text-gray-400 ml-1">tap a rate to add it as a line item</span>
      </button>
      {open && (
        <div className="overflow-x-auto mt-3">
          <table className="w-full text-xs border-collapse bg-white rounded">
            <thead>
              <tr className="bg-amber-100 text-amber-900">
                <th className="text-left p-2 border border-amber-200">Item</th>
                {RATE_TYPES.map((rt) => (
                  <th key={rt.key} className="text-right p-2 border border-amber-200 whitespace-nowrap">{rt.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {STANDARD_RATES.map((item, ri) => (
                <tr key={ri} className="hover:bg-amber-50">
                  <td className="p-2 border border-amber-100 font-medium whitespace-nowrap">{item.name}</td>
                  {RATE_TYPES.map((rt) => (
                    <td key={rt.key} className="p-1 border border-amber-100 text-right">
                      {item[rt.key] != null ? (
                        <button
                          type="button"
                          onClick={() => onAdd(rateToLineItem(item, rt.key))}
                          className="w-full text-right px-2 py-1 rounded hover:bg-amber-200 text-gray-700 font-medium"
                          data-testid={`rate-${ri}-${rt.key}`}
                          title={`Add: ${item.name} — ${rt.label}`}
                        >
                          ${Number(item[rt.key]).toFixed(2)}
                        </button>
                      ) : (
                        <span className="text-gray-300 pr-2">—</span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-[11px] text-gray-500 mt-1">LTA Permit and Escorts (per unit) are priced per job — add them as manual line items.</p>
        </div>
      )}
    </div>
  );
};

export default RateCardLibrary;
